import '../App.css';
import Speedometer, { Background, Arc, Needle, Progress, Marks, Indicator, DangerPath } from 'react-speedometer';

function Speed({ numberQuestion }) {

  const textSpeedometer = () => {
    if (window.innerWidth >= 760) {
      return (<text transform="rotate(80, 100, 105)" x="48" y="163" text-anchor="middle"
        font-size="18" font-family="squada-one" fill="black">שאלה {numberQuestion + 1}</text>)
    }

    else {
      return (<text transform="rotate(80, 100, 105)" x="36" y="170" text-anchor="middle"
        font-size="18" font-family="squada-one" fill="black">שאלה {numberQuestion + 1}</text>)
    }
  }

  return (
    <div className="Speed">
      <Speedometer value={numberQuestion + 1} max={30} angle={160}
        width={window.innerWidth >= 760 ? 120 : 100} fontFamily='squada-one' accentColor='#1e353a'>
        <Background angle={180} />
        <Arc color='#1f343989' arcWidth={6} opacity={1} />
        <Needle baseOffset={10} circleRadius={10} color="#f6ca3bfc" />
        <Progress color="#f6ca3bfc" arcWidth={7} />
        <Marks step={5} lineColor="#e94e4b" lineCap="#e94e4b" fontSize={10} lineSize={5} />
        <Indicator>
          {textSpeedometer}
        </Indicator>
      </Speedometer>
    </div>
  );
}

export default Speed;